export default [
  {
    path: '/commodityDetails',
    component: () => import('@/views/sharePage/CommodityDetails.vue'),
    name: 'commodityDetails',
    meta: {
      title: '商品详情',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/usercomments',
    component: () => import('@/views/sharePage/Comment.vue'),
    name: 'comment',
    meta: {
      title: '用户评价',
    },
  },
  {
    path: '/other',
    component: () => import('@/views/sharePage/Other.vue'),
    name: 'other',
    meta: {
      backgroundClass: 'bg-gray',
    },

    hidden: true,
  },
  {
    path: '/share/post.html',
    component: () => import('@/views/sharePage/Post.vue'),
    name: 'share-post',
    meta: {
      backgroundClass: 'bg-gray',
      title: '贴子详情',
    },
  },
  {
    path: '/share/activity.html',
    component: () => import('@/views/sharePage/Activity.vue'),
    name: 'share-activity',
    meta: {
      backgroundClass: 'bg-gray',
      title: '活动详情',
    },
  },
  {
    path: '/share/topic.html',
    component: () => import('@/views/sharePage/Topic.vue'),
    name: 'share-topic',
    meta: {
      backgroundClass: 'bg-gray',
      title: '话题详情',
    },
  },
  {
    path: '/share/postNewShare.html',
    component: () => import('@/views/sharePage/PostNewShare.vue'),
    name: 'share-trajectory',
    meta: {
      backgroundClass: 'bg-gray',
      title: '轨迹详情',
    },
  },
  {
    path: '/share/lottery.html',
    name: 'share-lottery',
    redirect: { name: 'activity.lottery' },
  },
  {
    path: '/group_share/group_share.html',
    redirect: { name: 'activity.groupRide' },
    name: 'share-groupRide',
  },
];
